import axios from 'axios';
import { DTON_API_ENDPOINT } from '~/config';

// const httpHeaders = DTON_API_KEY
//     ? { 'X-API-Key': DTON_API_KEY }
//     : undefined;

const http = axios.create({
    baseURL: DTON_API_ENDPOINT,
    // headers: httpHeaders,
});

export async function getAddressJettonListDton(address, limit = 20, page = 0) {
    const params = {
        page_size: limit,
        page,
        asset_type__in: 'jetton',
        raw_address: false,
    };

    const { data: list } = await http.get(`/assets/${address}`, { params });

    return list.data;
}

export async function getJettonInfoDton(address) {
    const { data: jetton } = await http.get(`/assets/token_info/${address}`);

    return jetton.data;
}
